export default {
    resalesLanding: {
        sentOn: "Gönderildi",
        toggleContact: "Emlak ofisi iletişim bilgilerini göster/gizle",
        propertyOffers: "Emlak teklifleri",
        openGallery: "Fotoğraf galerisini aç",
        prevPhoto: "Önceki fotoğraf",
        nextPhoto: "Sonraki fotoğraf",
        close: "Kapat",
        photo: "Fotoğraf",
        description: "Açıklama",
        more: "Daha fazla",
        less: "Daha az",
        intFloorSpace: "Kullanım alanı",
        build: "İnşaat alanı",
        terrace: "Teras",
        garden: "Bahçe",
        buildYear: "Yapım yılı",
        fees: "Giderler",
        communityFees: "Aidat",
        basuraTax: "Çöp vergisi (Basura)",
        ibiFees: "IBI (emlak vergisi)",
        securityDeposit: "Depozito",
        perMonth: "/ay",
        perWeek: "/hafta",
        disclaimer: "Yasal uyarı",
        energyCertificate: "Enerji sertifikası",
        pending: "Beklemede",
        rating: "Sınıf",
        presentedBy: "Sunan",
        propertyDetails: "Emlak detayları",
        reference: "Referans",
        referenceShort: "Ref",
        unitUnavailable: "Artık mevcut değil",
        availableUnits: "Müsait daireler ve fiyatlar",
        availableUnitsShort: "Müsait daireler",
        unit: "Daire",
        type: "Tip",
        floors: "Katlar",
        bedrooms: "Yatak odası",
        bathrooms: "Banyo",
        surfaceArea: "İç alan",
        price: "Fiyat",
        status: "Durum",
        unitAvailable: "Müsait",
        unitReserved: "Rezerve",
        unitSold: "Satıldı",
        seeMore: "Daha fazla göster",
        seeLess: "Daha az göster",
        floor: "Kat",
        storeys: "Kat sayısı",
        keyReady: "Anahtar teslim",
        touristLicence: "Turizm lisansı",
        firstOccupationLicence: "İlk iskân ruhsatı",
        notKnown: "Bilinmiyor",
        notProvided: "Belirtilmemiş",
        yes: "Evet",
        no: "Hayır",
        mortgageAvailable: "Kredi imkânı var",
        guaranteedRental: "Garantili kira geliri",
        sellBeforeCompletion: "Proje tamamlanmadan önce sözleşme devri",
        sellBeforeCompletionYes: "İzin veriliyor",
        sellBeforeCompletionNo: "İzin verilmiyor",
        sellBeforeCompletionNotProvided: "Belirtilmemiş",
        reservation: "Rezervasyon",
        contract: "Sözleşme",
        construction: "İnşaat",
        completion: "Teslim",
        co2: "CO2",
        energyConsumption: "Enerji tüketimi",
        co2PerYear: "kg CO2/yıl",
        kwhPerYear: "kWh/yıl",
        features: "Özellikler",
        viewDetails: "Detayları gör",
        hideDetails: "Emlak detaylarını gizle",
        backToResults: "Sonuçlar",
        viewProperty: "Mülkü görüntüle",
        prevProperty: "Önceki",
        nextProperty: "Sonraki",
        viewAllFeatures: "Tüm özellikleri gör",
        allFeatures: "Tüm özellikler",
        infoOnRequest: "Talep üzerine bilgi",
        tbc: "TBC",
        featureCategoryLabels: { pool: "Havuz", views: "Manzara", parking: "Otopark", kitchen: "Mutfak", condition: "Durum", garden: "Bahçe" },
        featureQualifierFormat: "{value} {category}",
        location: "Konum",
        agencyInformation: "Emlak ofisi bilgileri",
        buyingCosts: "Satın alma masrafları",
        propertyPrice: "Emlak fiyatı:",
        priceNote: "**Fiyata vergiler ve satın alma masrafları dâhil değildir.",
        estimatedPurchaseCosts: "Tahmini satın alma masrafları:",
        hide: "Gizle",
        showBreakdown: "Satın alma masraflarının dökümünü göster",
        purchaseCostBreakdown: "Satın alma masrafları dökümü",
        concept: "Kalem",
        application: "Uygulama",
        rowTransferTax: "ITP (devir vergisi, ikinci el konut)",
        rowVat: "KDV (sıfır konut)",
        rowVatLand: "KDV",
        vatApplication: "%10 (sosyal konutlarda %4)",
        rowStampDuty: "Damga vergisi (AJD)",
        rowNotary: "Noter",
        rowLandRegistry: "Tapu sicili",
        officialTariff: "Resmî tarife",
        costRangeNotePrefix: "*Alıcının toplam masrafları genellikle",
        and: "ile",
        ofPurchasePrice: "satış fiyatı arasında değişir.",
        costApproxNote: "*Tahmini satın alma maliyetleri yalnızca bilgilendirme amaçlıdır. Gerçek maliyetler mülke ve alıcının koşullarına göre değişebilir. Kesin bir hesaplama için profesyonel danışmanlık almanızı öneririz.",
        additionalInformation: "Ek bilgiler",
        addInfoDocument: "*218/2005 sayılı Endülüs Kararnamesi uyarınca Kısaltılmış Bilgi Belgesi mevcuttur",
        addInfoNoFees: "*Alıcı emlak komisyonu ödemez",
        formHeading: "Fiyatlar ve emlak hakkında daha fazla bilgi almak ister misiniz?",
        firstName: "Ad",
        enterNumber: "Numarayı girin",
        email: "E-posta",
        searchCountry: "Ülke veya kod ara",
        noMatches: "Sonuç yok",
        consent: "Düğmeye tıklayarak, sizinle iletişime geçmek ve gerekli bilgileri sunmak amacıyla verdiğiniz bilgilerin toplanması, saklanması ve kullanılması dâhil olmak üzere, kişisel verilerinizin Gizlilik Politikası uyarınca işlenmesine onay vermiş olursunuz.",
        send: "Gönder",
        contactUs: "Bize ulaşın",
        yourMessage: "Mesajınız",
        agreeData: "Bilgi talebime yanıt alabilmek için verilerimi paylaşmayı kabul ediyorum.",
        agreeContact: "Bilgilendirilmeyi talep ediyor ve bu amaçla gönüllü olarak verdiğim iletişim bilgilerim aracılığıyla projeden sorumlu şirket veya ilgili pazarlamacı tarafından benimle iletişime geçilmesini kabul ediyorum.",
        reject: "Reddet",
        like: "Beğen",
        liked: "Kaydedildi",
        rejected: "Reddedildi",
        offerRejected: "Teklif reddedildi",
        contact: "İletişim",
        call: "Ara",
        calling: "Aranıyor",
        noPhone: "Telefon numarası mevcut değil",
        enquirySent: "Talep gönderildi — iletişime geçeceğiz",
        yourDetails: "bilgileriniz",
        respondedTo: "yanıtlandı",
        noProperties: "Gösterilecek emlak yok.",
        soldOutBody: "Bu teklifteki mülkler satıldı veya artık piyasada değil. Güncel bir seçki için lütfen acenteyle iletişime geçin.",
        expiredTitle: "Bu teklif bağlantısının süresi doldu",
        expiredBody: "Bu emlakları görüntülemek için güncel bir bağlantı almak üzere lütfen emlak ofisiyle iletişime geçin.",
        unavailableTitle: "Teklif kullanılamıyor",
        unavailableBody: "Bu teklif yüklenemedi. Bağlantı geçersiz olabilir veya hizmet geçici olarak kullanılamıyor olabilir — lütfen daha sonra tekrar deneyin ya da emlak ofisiyle iletişime geçin.",
    },
    title: "{agencyName}'ın özellikleri",
    in: "in",
    propertiesFound: "özellikler bulundu",
    toDay: "Bugün",
    days: "günler",
    week: "Hafta",
    year: "Year",
    month: "Ay",
    prev: "Önceki",
    next: "Sonraki",
    backToList: "Listeye Dön",
    sorry: "Üzgünüz, biz",
    cantFind: "bulunamıyor",
    lookingFor: "aradığınız sayfa ...",
    thankYou: "WEB SİTEMİZİ ZİYARET ETTİĞİNİZ İÇİN TEŞEKKÜR EDERİZ",
    pleaseContact: "Lütfen yeni bir URL için Temsilci ile iletişime geçin.",
    ForSale: "SATIŞ",
    ShortTermRental: "Kısa Kira",
    LongTermRental: "Uzun Kiralama",
    showMore: "Daha Fazla Göster",
    showLess: "Daha Az Göster",
    price: "Fiyat",
    pricePer: "Fiyat",
    built: "edilmiş yapı",
    floorSpace: "İç yüzey alanı",
    terrace: "Teras",
    garden: "Bahçe",
    plot: "Konu",
    propTitle: '{subType} {searchType}, {location}',
    propTitleShort: "{subType}, {location}' içinde",
    notAvailable: "Kullanılamaz",
    notFound: 'Sayfa bulunamadı',
    emptyProperties: "Emlak bulunamadı, daha fazla bilgi için lütfen Temsilcinizle iletişime geçin.",
    linkExpired: "Bu bağlantının süresi doldu. Güncellenmiş bir tesis bağlantısı almak için emlakçınızla iletişime geçin.",
    newDevelopment: "Yeni Gelişme",
    agencyRaiiNo: "Ajansın sicil numarası",
    home: {
        verifyYourURLHere: "URL'nizi burada doğrulayın. Bunu yapmak için, web tarayıcınızda WhatsApp'a giriş yapın, ardından URL'yi WhatsApp'tan buraya kopyalayın.",
        pasteUrlHere: "URL'yi buraya yapıştırın",
        verifyUrl: "URL'yi Doğrula",
        whatIsPropertyViewer: "Property-Viewer.com nedir?",
        thisIsWebsiteIsUsed: "Bu web sitesi Emlakçılar tarafından müşterilerine mülk göndermek için kullanılmaktadır. {resalesonlinecom}'un bir ürünüdür Şüpheniz varsa, lütfen ile konuşun emlak listenizi size gönderen Temsilci.",
        howDoesItWork: "Hur fungerar det?",
        inThePast: "Geçmişte, Aracılar müşterilerine PDF belgeleri gönderirdi. Ancak, bu birçok cihazda görüntülemek kolay değildir. Bu nedenle, istemcinin kendilerine gönderilen özellikleri daha kolay görüntüleyebilmeleri için {propertyviewercom} oluşturduk.",
        createAShortList: "Aracı, özelliklerin kısa bir listesini oluşturur. Bu özellikleri sizinle paylaştıklarında, bir bağlantı alırsınız. Bu bağlantıyı tıklattığınızda özellikleri gösterecektir."
    },

    list: {
        propertyTitle: "Bu özelliğin bilgilerini görüntülemek için burayı tıklatın"
    },

    searchType: {
        ForSale: "satılık",
        ShortTermRental: "kısa süreli kiralama için",
        LongTermRental: "uzun süreli kiralama için",
    },

    rsStatus: {
        Available: "Mevcut",
        Listing: "Liste",
        UnderOffer: "Teklif Altında",
        SaleAgreed: "Satış Kabul Edildi",
        OffMarket: "Piyasa Dışı",
        Sold: "Satılan",
        Rented: "Kirala"
    },

    details: {
        average: "Ortalama",
        averagePricesFor: "Ortalama fiyatlar",
        showFullER: "Tam Göster",
        thisProperty: "Bu mülk",
        infoNotAvailable: "Bu bilgi mevcut değil.",
        feesEnergyRating: "Ücretler, Enerji Derecelendirmesi",
        fees: "Ücretler",
        ibiFees: "IBI Ücretleri",
        basuraTax: "Basura Vergisi",
        communityFees: "Topluluk Ücretleri",
        associatedCosts: "İlişkili Maliyetler",
        energyRating: "Enerji Sınıfı",
        securityDeposit: "Depozito",
        energyCertificate: "Enerji sertifikası",
        energyCertificatePending: "Enerji sertifikası beklemede",
        energyConsumption: "Enerji Tüketimi",
        co2: "CO₂",
        co2PerYear: "kgCO₂ / m² / yıl",
        kwhPerYear: "kWh / m² / yıl",
        other: "Diğer",
        buildYear: "Yapım yılı",
        forSale: "Satılık",
        sold: "Satıldı",
        longTerm: "Uzun vadeli",
        shortTermHigh: "Kısa vadeli yüksek",
        shortTermLow: "Kısa vadeli düşük",
        allFeatures: "Tüm özellikler",
        aproxLocation: "Aprox. Konum",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Turist Kayıt Numarası",
        agencyInformation: "Ajans Bilgileri",
    },
};